import React from 'react';
import { Toast, ToastTitle, ToastDescription, ToastClose } from './toast';
import { CheckCircle, AlertCircle, Info, X } from 'lucide-react';

const ToastContainer = ({ toasts, dismiss }) => {
  if (!toasts || toasts.length === 0) return null;

  const getIcon = (variant) => {
    switch (variant) {
      case 'success':
        return <CheckCircle className="h-4 w-4 text-green-500" />;
      case 'destructive':
        return <AlertCircle className="h-4 w-4 text-red-500" />;
      case 'info':
        return <Info className="h-4 w-4 text-blue-500" />;
      default:
        return <Info className="h-4 w-4 text-gray-500" />;
    }
  };

  return (
    <div className="fixed top-4 right-4 z-50 flex flex-col gap-2 max-w-sm">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          variant={toast.variant}
          className="shadow-lg"
        >
          <div className="flex items-start gap-3">
            {getIcon(toast.variant)}
            <div className="flex-1">
              {toast.title && (
                <ToastTitle>{toast.title}</ToastTitle>
              )}
              {toast.description && (
                <ToastDescription>{toast.description}</ToastDescription>
              )}
            </div>
          </div>
          <ToastClose onClick={() => dismiss(toast.id)}>
            <X className="h-4 w-4" />
          </ToastClose>
        </Toast>
      ))}
    </div>
  );
};

export default ToastContainer; 